import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v8.5","key":"svg-0"}],["path",{"d":"M9 4v13","key":"svg-1"}],["path",{"d":"M15 7v5.5","key":"svg-2"}],["path",{"d":"M16 21l5 -5","key":"svg-3"}],["path",{"d":"M21 21v.01","key":"svg-4"}],["path",{"d":"M16 16v.01","key":"svg-5"}]]

const IconMapDiscount = createReactComponent('outline', 'map-discount', 'MapDiscount', __iconNode);

export default IconMapDiscount;